import React, { memo } from "react";
import "../styles.css";
import { TabItem } from "../types";
import { COLORS } from "../constants";

// Re-export TabItem for backward compatibility
export type { TabItem };

interface TabsBarProps {
  tabs: TabItem[];
  activeTab: string;
  onChange: (tabId: string) => void;
}

const TabsBar: React.FC<TabsBarProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <div style={{ borderBottom: `1px solid ${COLORS.BORDER_LIGHT}` }} className="tabs-bar">
      <div className="tabs-list">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.id;

          return (
            <button
              key={tab.id}
              disabled={tab.disabled}
              onClick={() => !tab.disabled && onChange(tab.id)}
              style={{
                position: "relative",
                background: "transparent",
                border: "none",
                padding: "12px 0",
                cursor: tab.disabled ? "not-allowed" : "pointer",
                fontWeight: isActive ? 700 : 600,
                fontSize: '15px',
                color: '#201747'
              }}
              // className="tableHeader"
            >
              {tab.label}

              {isActive && (
                <span
                  className="tabs-indicator"
                />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default memo(TabsBar);
